
      import styled from "styled-components";

      const SettingsStyled = styled.div``;

      export { SettingsStyled };
      